import React from "react";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";
import "containers/Spotlight/MySpotlight.css";
import "containers/ProjectCommon.css";
import "./MyFriends.css";
import "components/General/Form/CustomButton/TwoButtonLayout.css";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import FriendListContainer from "components/Tribe/Friends/FriendsHome/FriendListContainer";
import FriendGroupChildrenToggle from "components/Tribe/FriendGroupChildrenToggle";
import SearchNewUsers from "components/Tribe/Friends/FriendsHome/SearchNewUsers";
import FriendsSearchGrid from "components/Project/StartProject/Step_3/FriendsSearchGrid";
import * as FriendsSearchHelper from "components/Project/FriendsSearcHelper/FriendsSearchHelper";
import RoundedButton from "../../../../components/General/Form/CustomButton/RoundedButton";
import TextTheme from "../../../../components/General/Text/TextTheme";

/*************************************************
 * This is the main friend class that composes
 * the entire Friend Tribe page.
 */
class MyFriends extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invitations: [], // will contain all friend invitations sent from other users
      requests: [], // will contain all friend requests this user has sent
      friends: [], // will contain all this users current friends
      recommendedFriends: [], // will contain any recommendations of users to friend
      //state variables for user search, ref from StartProjectStepThree.j
      popupSearch: false,
      friendsSearchData: [],
      searchType: "",
      searchValue: "",
      searchPage: 1,
      searchOrigin: CONSTANT.FRIENDS,
      searchMoreAvailable: true,
      searchLessAvailable: true,
      currentFriendPage: 1,
      userType: undefined,
    };
    // handle each friend section page change
    this.handleFriendPageChange = this.handleFriendPageChange.bind(this);
  }

  /*************
   * When the component mounts fetch the 4 different lists and
   * check if this user has children.
   */
  componentDidMount() {
    this.fetchFriendInvitations(this);
    this.fetchFriendRequests(this);
    this.fetchAcceptedFriends(this);
    this.fetchRecommendedFriends(this);
    AxiosConfig.get(`/profile/details/`)
      .then((response) => {
        this.setState({ userType: response.data.user_type });
      })
      .catch(function (error) {});
  }

  /******************************************************************
   * Get the friend invitations sent to this user
   */
  fetchFriendInvitations(obj) {
    AxiosConfig.get("friends/requests/pending/").then(function (response) {
      obj.setFriendInvitationList(response);
    });
  }
  /**
   * Set the state for friend invitations
   */
  setFriendInvitationList(response) {
    let friendInvitationList = response.data;
    this.setState((prevState) => ({
      invitations: friendInvitationList,
    }));
  }

  /******************************************************************
   * Get the friend requests sent by this user
   */
  fetchFriendRequests(obj) {
    AxiosConfig.get("friends/requests/sent/").then(function (response) {
      obj.setFriendRequestList(response);
    });
  }
  /**
   * Set the state for friend requests
   */
  setFriendRequestList(response) {
    let friendRequestList = response.data;
    this.setState((prevState) => ({
      requests: friendRequestList,
    }));
  }

  /******************************************************************
   * Get the friend's of this user
   */
  fetchAcceptedFriends(obj) {
    AxiosConfig.get("friends/list/", {
      params: { filter: "" },
    }).then(function (response) {
      obj.setFriendsList(response);
    });
  }
  /**
   * Set the state for friends
   */
  setFriendsList(response) {
    let friendList = response.data;
    this.setState((prevState) => ({
      friends: friendList,
    }));
  }

  /******************************************************************
   * Get the recommendations of users' this user should friend
   */
  fetchRecommendedFriends(obj) {
    AxiosConfig.get("friends/recommendations/").then(function (response) {
      obj.setRecommendedList(response);
    });
  }
  /**
   * Set recommendation list
   */
  setRecommendedList(response) {
    this.setState((prevState) => ({
      recommendedFriends: response.data,
    }));
  }

  //ref containers/Projects/StartProject/Step_3/StartProjectStepThree.js
  fetchFriendsData(obj, searchType, searchValue, page, searchMoreFlag) {
    FriendsSearchHelper.fetchFriendsDataHelper(
      obj,
      searchType,
      searchValue,
      page,
      searchMoreFlag
    );
  }

  /*****************************************************************
   * Button handler to filter the friend list by the parameter in the
   * search field for the Friends section.
   * Will make a new call to backend to filter the friend list
   */
  filterFriends(filterValue) {
    let self = this;
    //used to set the page back to 1 so that filtered friends render.
    this.setState({ currentFriendPage: 1 });
    AxiosConfig.get("friends/list/", { params: { filter: filterValue } }).then(
      function (response) {
        self.setState({ friends: response.data });
      }
    );
  }

  /*Used to change the current page on the friends list*/
  handleFriendPageChange(page) {
    this.setState({ currentFriendPage: page });
  }

  /*****************************************************************
   * main render method
   */

  /******
   * Invite more friends
   */
  onInviteFriend() {
    window.location.assign("/build-your-team");
  }
  render() {
    return (
      <div className="header_main main_friends">
        <div className="page_main main_page">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>
          <div className="page_details_main tribe">
            <div className="mb-15 friend_group_button">
              <FriendGroupChildrenToggle activeTab={CONSTANT.FRIENDS} />
            </div>
            {/*ref code from containers/Projects/StartProject/Step_3/StartProjectStepThree.js*/}
            {this.state.popupSearch ? (
                  <FriendsSearchGrid
                    searchData={this.state.friendsSearchData}
                    searchStringType={this.state.searchType}
                    searchStringValue={this.state.searchValue}
                    searchMore={this.state.searchMoreAvailable}
                    searchLess={this.state.searchLessAvailable}
                    searchResultCancelClick={FriendsSearchHelper.searchResultCancelClick.bind(
                      this
                    )}
                    searchResultDoneClick={FriendsSearchHelper.searchResultDoneClick.bind(
                      this
                    )}
                    searchResultNextClick={FriendsSearchHelper.searchResultNextClick.bind(
                      this
                    )}
                    searchResultBackClick={FriendsSearchHelper.searchResultBackClick.bind(
                      this
                    )}
                    searchResultViewClick={FriendsSearchHelper.searchResultViewClick.bind(
                      this
                    )}
                  />
            ) : (
              null
            )}
            {/**************************INVITATIONS**********************************/}
            <div className="mb-15 page_details_content_main">
              <div className="textHeader">{CONSTANT.INVITATIONS}</div>
              {this.state.invitations && this.state.invitations.length > 0 ? (
                <FriendListContainer
                  buttonTitle={CONSTANT.BUTTON_VIEW}
                  friendLists={this.state.invitations}
                  datePrefix={CONSTANT.PREFIX_RECEIVED}
                  type={CONSTANT.INVITATIONS}
                />
              ) : (
                <TextTheme
                  message={CONSTANT.NO_NEW_FRIEND_INVITATIONS}
                  className="mt-15 mb-15 text_small text_med_grey text-center"
                />
              )}
            </div>
            {/***************************REQUESTS***********************************/}
            <div className="mb-15 page_details_content_main">
              <div className="textHeader">{CONSTANT.REQUESTS}</div>
                {this.state.requests && this.state.requests.length > 0 ? (
                  <FriendListContainer
                    buttonTitle={CONSTANT.BUTTON_VIEW}
                    friendLists={this.state.requests}
                    datePrefix={CONSTANT.PREFIX_SENT}
                    type={CONSTANT.REQUESTS}
                  />
                ) : (
                  <TextTheme
                  message={CONSTANT.NO_NEW_FRIEND_REQUESTS}
                  className="mt-15 mb-15 text_small text_med_grey text-center"
                />
                  // <div
                  //   className="message"
                  //   style={{ margin: "0", textAlign: "center", padding: "0px" }}
                  // >
                  //   {CONSTANT.NO_NEW_FRIEND_REQUESTS}
                  //   <br />
                  //   <br />
                  // </div>
                )}
            </div>
            {/***************************FRIENDS***********************************/}
            <div className="mb-15 page_details_content_main">
              <div className="mb-15 title_search_header">
                <div className="textHeader">{CONSTANT.FRIENDS}</div>
                <div className="friend_search_container">
                  <SearchNewUsers
                    searchResultHandler={this.filterFriends.bind(this)}
                    placeholder={CONSTANT.FIND_YOUR_FRIENDS}
                  />
                </div>
              </div>
              {this.state.friends && this.state.friends.length > 0 ? (
                <FriendListContainer
                  buttonTitle={CONSTANT.BUTTON_VIEW}
                  friendLists={this.state.friends}
                  datePrefix={CONSTANT.PREFIX_SINCE}
                  type={CONSTANT.FRIENDS}
                  currentFriendPage={this.state.currentFriendPage}
                  handleFriendPageChange={this.handleFriendPageChange}
                />
              ) : (
                <TextTheme
                  message={CONSTANT.NO_FRIENDS}
                  className="mt-15 mb-15 text_small text_med_grey text-center"
                />
              )}
            </div>
            {/**************************RECOMMENDATIONS**********************************/}
            <div className="page_details_content_main">
              <div className="mb-15 title_search_header">
                <div className="textHeader">{CONSTANT.PEOPLE_YOU_MAY_KNOW}</div>
                <div className="friend_search_container">
                  <SearchNewUsers
                    searchResultHandler={FriendsSearchHelper.searchResultHandler.bind(
                      this
                    )}
                    placeholder={CONSTANT.FIND_NEW_FRIENDS}
                  />
                </div>
              </div>
              {this.state.recommendedFriends.length !== 0 ? (
                <FriendListContainer
                  buttonTitle={CONSTANT.BUTTON_VIEW}
                  friendLists={this.state.recommendedFriends}
                  type={CONSTANT.RECOMMENDATIONS}
                  searchResultViewClick={FriendsSearchHelper.searchResultViewClick.bind(
                    this
                  )}
                />
              ) : (
                <TextTheme
                  message={CONSTANT.SEARCH_FOR_NEW_FRIENDS}
                  className="mt-15 mb-15 d-inline-block w-100 text_small text_med_grey text-center"
                />
              )}
              {this.state.userType != "child" ? (
                <div className="text-right invite-more">
                  <RoundedButton
                    title="Invite a Friend"
                    buttonClassName="background_dark_orange"
                    textThemeClassName="text_medium text_white"
                    handleOnClick={this.onInviteFriend.bind(this)}
                    margin="20px 0 0 0"
                    borderRadius="6px"
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MyFriends;
